const $ = require('jquery');

let $tabGroups;

function _init() {
    $tabGroups = $('.tab-group');

    if ($tabGroups.length === 0) {
        return;
    }

    $tabGroups.each(function() {
        let $tabGroup = $(this);
        $tabGroup.on('click', '.js-tab', (event) => {
            let $tabButton = $(event.currentTarget);

            $tabGroup.find('.js-tab, .tabContent')
                .removeClass('is-active')
                .removeAttr('disabled');

            $tabButton.addClass('is-active').prop('disabled', true);

            $tabGroup.find('.tabContent').filter(`:eq(${$tabButton.index()})`).addClass('is-active');

            $tabGroup.trigger('tab-change', $tabButton);
        });
    });
}

document.addEventListener('DOMContentLoaded', _init);